module.exports = __webpack_public_path__ + "img/Majungasaurus_Splash.8dede211.webp";